import React, { useState } from 'react';
import { MapPinIcon, StarIcon, CalendarIcon, ClockIcon, FileTextIcon, ShieldIcon, DownloadIcon, InfoIcon, CheckCircleIcon, UserIcon, BuildingIcon, TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
const MicroSukukDetails = () => {
  const [investmentAmount, setInvestmentAmount] = useState(1000);
  return <div className="max-w-4xl mx-auto" data-id="element-783">
      {/* Header Section */}
      <div className="mb-6" data-id="element-784">
        <div className="flex items-center gap-2 text-neutral-400 text-sm mb-2" data-id="element-785">
          <span data-id="element-786">Sukuk Marketplace</span>
          <span data-id="element-787">•</span>
          <span data-id="element-788">MS2023-104</span>
        </div>
        <div className="flex justify-between items-start" data-id="element-789">
          <div data-id="element-790">
            <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-791">
              Equipment Financing Micro-Sukuk
            </h1>
            <p className="text-neutral-400" data-id="element-792">
              Amani Cafe • Equipment Purchase • RM 50,000
            </p>
          </div>
          <div className="bg-primary bg-opacity-10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-793">
            Open for Investment
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-794">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-6" data-id="element-795">
          {/* Business Profile */}
          <Card data-id="element-796">
            <div className="flex flex-col md:flex-row gap-6" data-id="element-797">
              <div className="md:w-1/3" data-id="element-798">
                <div className="h-48 bg-cover bg-center rounded-lg mb-4" style={{
                backgroundImage: "url('https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
              }} data-id="element-799"></div>
                <h3 className="font-bold text-lg mb-2" data-id="element-800">Amani Cafe</h3>
                <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-801">
                  <MapPinIcon className="w-4 h-4 mr-1" data-id="element-802" />
                  <span data-id="element-803">Kuala Lumpur</span>
                </div>
                <div className="flex items-center mb-4" data-id="element-804">
                  <div className="flex" data-id="element-805">
                    {[1, 2, 3, 4].map(star => <StarIcon key={star} className="w-4 h-4 text-accent" fill="currentColor" data-id="element-806" />)}
                    <StarIcon className="w-4 h-4 text-neutral-200" data-id="element-807" />
                  </div>
                  <span className="text-xs text-neutral-400 ml-2" data-id="element-808">
                    4.0 (15 reviews)
                  </span>
                </div>
              </div>
              <div className="md:w-2/3" data-id="element-809">
                <h4 className="font-medium mb-3" data-id="element-810">Business Overview</h4>
                <p className="text-sm text-neutral-500 mb-4" data-id="element-811">
                  Amani Cafe is a specialty coffee shop established in 2020,
                  serving premium coffee and light meals. The business has shown
                  consistent growth and maintains a strong customer base in the
                  Kuala Lumpur city center.
                </p>
                <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-812">
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-813">
                    <div className="text-xs text-neutral-400" data-id="element-814">Years Active</div>
                    <div className="font-medium" data-id="element-815">3+ Years</div>
                  </div>
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-816">
                    <div className="text-xs text-neutral-400" data-id="element-817">Team Size</div>
                    <div className="font-medium" data-id="element-818">8 Employees</div>
                  </div>
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-819">
                    <div className="text-xs text-neutral-400" data-id="element-820">
                      Monthly Revenue
                    </div>
                    <div className="font-medium" data-id="element-821">RM 45,000</div>
                  </div>
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-822">
                    <div className="text-xs text-neutral-400" data-id="element-823">
                      Location Type
                    </div>
                    <div className="font-medium" data-id="element-824">Shopping Mall</div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          {/* Rating Agency Assessment */}
          <Card data-id="element-825">
            <div className="flex items-center mb-4" data-id="element-826">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-827">
                <StarIcon className="w-5 h-5 text-success" data-id="element-828" />
              </div>
              <div data-id="element-829">
                <h3 className="font-medium" data-id="element-830">Rating Agency Assessment</h3>
                <p className="text-sm text-neutral-400" data-id="element-831">
                  Evaluated by Malaysian Rating Corporation
                </p>
              </div>
              <div className="ml-auto bg-success bg-opacity-10 text-success px-3 py-1 rounded-full text-sm font-medium" data-id="element-832">
                Low Risk (A)
              </div>
            </div>
            <div className="space-y-4 mb-6" data-id="element-833">
              <div data-id="element-834">
                <div className="flex justify-between text-sm mb-1" data-id="element-835">
                  <span data-id="element-836">Business Stability</span>
                  <span className="text-success" data-id="element-837">Strong</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-838">
                  <div className="bg-success h-2 rounded-full" style={{
                  width: '80%'
                }} data-id="element-839"></div>
                </div>
              </div>
              <div data-id="element-840">
                <div className="flex justify-between text-sm mb-1" data-id="element-841">
                  <span data-id="element-842">Financial Health</span>
                  <span className="text-success" data-id="element-843">Excellent</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-844">
                  <div className="bg-success h-2 rounded-full" style={{
                  width: '90%'
                }} data-id="element-845"></div>
                </div>
              </div>
              <div data-id="element-846">
                <div className="flex justify-between text-sm mb-1" data-id="element-847">
                  <span data-id="element-848">Market Position</span>
                  <span className="text-success" data-id="element-849">Good</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-850">
                  <div className="bg-success h-2 rounded-full" style={{
                  width: '75%'
                }} data-id="element-851"></div>
                </div>
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg text-sm" data-id="element-852">
              <h4 className="font-medium mb-2" data-id="element-853">Rating Summary</h4>
              <p className="text-neutral-500 mb-4" data-id="element-854">
                Amani Cafe demonstrates strong business fundamentals with
                consistent revenue growth and robust cash flow management. The
                business has maintained a stable customer base and shows good
                potential for expansion.
              </p>
              <div className="space-y-2" data-id="element-855">
                <div className="flex items-start" data-id="element-856">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-857" />
                  <span data-id="element-858">Strong track record of timely supplier payments</span>
                </div>
                <div className="flex items-start" data-id="element-859">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-860" />
                  <span data-id="element-861">Healthy profit margins above industry average</span>
                </div>
                <div className="flex items-start" data-id="element-862">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-863" />
                  <span data-id="element-864">
                    Experienced management team with industry expertise
                  </span>
                </div>
              </div>
            </div>
          </Card>
          {/* Shariah Compliance */}
          <Card data-id="element-865">
            <div className="flex items-center mb-4" data-id="element-866">
              <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-867">
                <ShieldIcon className="w-5 h-5 text-secondary" data-id="element-868" />
              </div>
              <div data-id="element-869">
                <h3 className="font-medium" data-id="element-870">Shariah Compliance Review</h3>
                <p className="text-sm text-neutral-400" data-id="element-871">
                  Certified by Shariah Advisory Board
                </p>
              </div>
              <div className="ml-auto bg-secondary bg-opacity-10 text-secondary px-3 py-1 rounded-full text-sm font-medium" data-id="element-872">
                Fully Compliant
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg text-sm mb-4" data-id="element-873">
              <h4 className="font-medium mb-2" data-id="element-874">Compliance Summary</h4>
              <p className="text-neutral-500 mb-4" data-id="element-875">
                The micro-sukuk structure and business activities have been
                reviewed and certified as Shariah-compliant. The equipment
                financing follows the Ijarah (lease) principle with clear terms
                and conditions.
              </p>
              <div className="space-y-2" data-id="element-876">
                <div className="flex items-start" data-id="element-877">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-878" />
                  <span data-id="element-879">Business activities are halal and permissible</span>
                </div>
                <div className="flex items-start" data-id="element-880">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-881" />
                  <span data-id="element-882">Financing structure follows Islamic principles</span>
                </div>
                <div className="flex items-start" data-id="element-883">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 mt-0.5" data-id="element-884" />
                  <span data-id="element-885">Clear profit-sharing mechanism in place</span>
                </div>
              </div>
            </div>
            <div className="flex items-center text-sm text-neutral-400" data-id="element-886">
              <UserIcon className="w-4 h-4 mr-2" data-id="element-887" />
              <span data-id="element-888">
                Reviewed by: Dr. Fatimah Ismail, Head of Shariah Advisory
              </span>
            </div>
          </Card>
          {/* Business Performance */}
          <Card data-id="element-889">
            <div className="flex items-center mb-4" data-id="element-890">
              <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-891">
                <div className="w-5 h-5 text-primary" data-id="element-892" />
              </div>
              <h3 className="font-medium" data-id="element-893">Business Performance</h3>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-894">
              <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-895">
                <div className="text-sm text-neutral-400 mb-1" data-id="element-896">
                  Monthly Revenue
                </div>
                <div className="text-xl font-bold" data-id="element-897">RM 45,000</div>
                <div className="flex items-center text-xs text-success mt-1" data-id="element-898">
                  <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-899" />
                  <span data-id="element-900">+15% vs last year</span>
                </div>
              </div>
              <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-901">
                <div className="text-sm text-neutral-400 mb-1" data-id="element-902">
                  Profit Margin
                </div>
                <div className="text-xl font-bold" data-id="element-903">25%</div>
                <div className="flex items-center text-xs text-success mt-1" data-id="element-904">
                  <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-905" />
                  <span data-id="element-906">+5% vs industry average</span>
                </div>
              </div>
            </div>
            <div className="space-y-4" data-id="element-907">
              <div data-id="element-908">
                <div className="flex justify-between text-sm mb-1" data-id="element-909">
                  <span data-id="element-910">Customer Growth</span>
                  <span data-id="element-911">+30% YoY</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-912">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '75%'
                }} data-id="element-913"></div>
                </div>
              </div>
              <div data-id="element-914">
                <div className="flex justify-between text-sm mb-1" data-id="element-915">
                  <span data-id="element-916">Repeat Customers</span>
                  <span data-id="element-917">65%</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-918">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '65%'
                }} data-id="element-919"></div>
                </div>
              </div>
            </div>
          </Card>
          {/* Documents */}
          <Card data-id="element-920">
            <h3 className="font-medium mb-4" data-id="element-921">Supporting Documents</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-922">
              <div className="border border-neutral-200 rounded-lg p-4" data-id="element-923">
                <div className="flex items-center mb-3" data-id="element-924">
                  <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-925">
                    <ShieldIcon className="w-4 h-4 text-secondary" data-id="element-926" />
                  </div>
                  <h4 className="font-medium" data-id="element-927">Shariah Certificate</h4>
                </div>
                <p className="text-xs text-neutral-400 mb-4" data-id="element-928">
                  Shariah compliance certification
                </p>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-930" />} iconPosition="left" fullWidth data-id="element-929">
                  Download
                </Button>
              </div>
              <div className="border border-neutral-200 rounded-lg p-4" data-id="element-931">
                <div className="flex items-center mb-3" data-id="element-932">
                  <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-933">
                    <StarIcon className="w-4 h-4 text-secondary" data-id="element-934" />
                  </div>
                  <h4 className="font-medium" data-id="element-935">Rating Report</h4>
                </div>
                <p className="text-xs text-neutral-400 mb-4" data-id="element-936">
                  Detailed risk assessment
                </p>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-938" />} iconPosition="left" fullWidth data-id="element-937">
                  Download
                </Button>
              </div>
              <div className="border border-neutral-200 rounded-lg p-4" data-id="element-939">
                <div className="flex items-center mb-3" data-id="element-940">
                  <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-941">
                    <FileTextIcon className="w-4 h-4 text-secondary" data-id="element-942" />
                  </div>
                  <h4 className="font-medium" data-id="element-943">Business Profile</h4>
                </div>
                <p className="text-xs text-neutral-400 mb-4" data-id="element-944">
                  Company information
                </p>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-946" />} iconPosition="left" fullWidth data-id="element-945">
                  Download
                </Button>
              </div>
            </div>
          </Card>
        </div>
        {/* Investment Panel */}
        <div className="space-y-6" data-id="element-947">
          <Card data-id="element-948">
            <div className="mb-6" data-id="element-949">
              <div className="flex justify-between text-sm mb-1" data-id="element-950">
                <span data-id="element-951">Funding Progress</span>
                <span data-id="element-952">65% (RM 32,500)</span>
              </div>
              <div className="w-full bg-neutral-200 rounded-full h-2.5 mb-1" data-id="element-953">
                <div className="bg-primary h-2.5 rounded-full" style={{
                width: '65%'
              }} data-id="element-954"></div>
              </div>
              <div className="flex justify-between text-xs text-neutral-400" data-id="element-955">
                <div data-id="element-956">RM 32,500 raised</div>
                <div data-id="element-957">RM 50,000 target</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-958">
              <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-959">
                <div className="text-xs text-neutral-400" data-id="element-960">Term</div>
                <div className="font-medium" data-id="element-961">6 months</div>
              </div>
              <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-962">
                <div className="text-xs text-neutral-400" data-id="element-963">Profit Rate</div>
                <div className="font-medium" data-id="element-964">18% p.a.</div>
              </div>
              <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-965">
                <div className="text-xs text-neutral-400" data-id="element-966">Min. Investment</div>
                <div className="font-medium" data-id="element-967">RM 100</div>
              </div>
              <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-968">
                <div className="text-xs text-neutral-400" data-id="element-969">Max. Investment</div>
                <div className="font-medium" data-id="element-970">RM 5,000</div>
              </div>
            </div>
            <div className="mb-6" data-id="element-971">
              <label className="block text-sm mb-2" data-id="element-972">
                Investment Amount (RM)
              </label>
              <input type="range" min="100" max="5000" step="100" value={investmentAmount} onChange={e => setInvestmentAmount(parseInt(e.target.value))} className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer" data-id="element-973" />
              <div className="flex justify-between text-xs text-neutral-400 mt-1" data-id="element-974">
                <span data-id="element-975">Min: RM 100</span>
                <span data-id="element-976">Max: RM 5,000</span>
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg mb-6" data-id="element-977">
              <div className="space-y-3" data-id="element-978">
                <div className="flex justify-between" data-id="element-979">
                  <span className="text-sm text-neutral-400" data-id="element-980">
                    Your Investment
                  </span>
                  <span className="font-medium" data-id="element-981">
                    RM {investmentAmount.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-982">
                  <span className="text-sm text-neutral-400" data-id="element-983">
                    Expected Return
                  </span>
                  <span className="font-medium text-success" data-id="element-984">
                    RM{' '}
                    {Math.round(investmentAmount * 0.18 * (6 / 12)).toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-985">
                  <span className="text-sm text-neutral-400" data-id="element-986">
                    Maturity Value
                  </span>
                  <span className="font-medium" data-id="element-987">
                    RM{' '}
                    {Math.round(investmentAmount * (1 + 0.18 * (6 / 12))).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
            <Button variant="primary" fullWidth data-id="element-988">
              Invest Now
            </Button>
            <div className="flex items-center justify-center mt-4" data-id="element-989">
              <ClockIcon className="w-4 h-4 text-neutral-400 mr-1" data-id="element-990" />
              <span className="text-sm text-neutral-400" data-id="element-991">10 days left</span>
            </div>
          </Card>
          <Card data-id="element-992">
            <h3 className="font-medium mb-4" data-id="element-993">Investment Protection</h3>
            <div className="space-y-3" data-id="element-994">
              <div className="flex items-start" data-id="element-995">
                <CheckCircleIcon className="w-5 h-5 text-success mr-2 mt-0.5" data-id="element-996" />
                <div data-id="element-997">
                  <div className="font-medium text-sm" data-id="element-998">Secured Asset</div>
                  <p className="text-xs text-neutral-400" data-id="element-999">
                    Equipment serves as underlying asset
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1000">
                <CheckCircleIcon className="w-5 h-5 text-success mr-2 mt-0.5" data-id="element-1001" />
                <div data-id="element-1002">
                  <div className="font-medium text-sm" data-id="element-1003">Trustee Oversight</div>
                  <p className="text-xs text-neutral-400" data-id="element-1004">
                    Independent trustee manages funds
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1005">
                <CheckCircleIcon className="w-5 h-5 text-success mr-2 mt-0.5" data-id="element-1006" />
                <div data-id="element-1007">
                  <div className="font-medium text-sm" data-id="element-1008">Direct Debit</div>
                  <p className="text-xs text-neutral-400" data-id="element-1009">
                    Automated repayment collection
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};
export default MicroSukukDetails;